function generateRandomUUID() {
  return crypto.randomUUID();
}

const HANDOFF_DATA_MESSAGE_ID_PREFIX = "handoff-data-";
const INITIAL_MESSAGE_ID_PREFIX = "initial-message-";
const TOOL_CANCELLED_MESSAGE = "Tool cancelled by user";
const TOOL_CANCELLED_RESULT = {
  cancelled: true,
  message: TOOL_CANCELLED_MESSAGE,
  success: false,
  status: "cancelled"
};
const ADDITIONAL_HANDOFF_DATA_STRING = "<additionalHandoffData>";
const ADDITIONAL_HANDOFF_DATA_STRING_END = "</additionalHandoffData>";
const createHandoffDataMessages = (fromCopilotId, toCopilotId, handoffData) => {
  const content = `

  Handoff data provided by ${fromCopilotId}:
  ${ADDITIONAL_HANDOFF_DATA_STRING}
  ${JSON.stringify(handoffData)}
  ${ADDITIONAL_HANDOFF_DATA_STRING_END}

  Conversation has been handed over to ${toCopilotId} from ${fromCopilotId}.
  Conversation will now continue in ${toCopilotId}.
  `;
  return [
    {
      id: `${HANDOFF_DATA_MESSAGE_ID_PREFIX}${generateRandomUUID()}-${fromCopilotId}`,
      role: "data",
      content,
      parts: [{ type: "text", text: content }]
    }
  ];
};
const isHandoffDataMessage = (message) => {
  return message.id.startsWith(HANDOFF_DATA_MESSAGE_ID_PREFIX);
};
const isInitialMessage = (message) => {
  return message.id.startsWith(INITIAL_MESSAGE_ID_PREFIX);
};
function idempotentMapToStructuredInitialMessages(initialMessages) {
  return initialMessages.map((m) => {
    if (isInitialMessage(m)) {
      return m;
    } else {
      return {
        ...m,
        id: `${INITIAL_MESSAGE_ID_PREFIX}${m.id}`
      };
    }
  });
}
function findImmediateHandoffAndInitialMessages(messages) {
  const emptyResult = { initialMessages: [], handoffMessages: [] };
  if (messages.length === 0) {
    return emptyResult;
  }
  const lastMessage = messages[messages.length - 1];
  if (lastMessage.role !== "user") {
    return emptyResult;
  }
  if (messages.length === 1) {
    return emptyResult;
  }
  const takeConsecutiveFromEnd = (arr, predicate, fromIndex = arr.length - 1) => {
    const items = [];
    let currentIndex = fromIndex;
    while (currentIndex >= 0 && predicate(arr[currentIndex])) {
      items.unshift(arr[currentIndex]);
      currentIndex--;
    }
    return { items, lastIndex: currentIndex };
  };
  const messagesBeforeUser = messages.slice(0, -1);
  const { items: initialMessages, lastIndex: lastNonInitialIndex } = takeConsecutiveFromEnd(messagesBeforeUser, isInitialMessage);
  const handoffSearchStartIndex = initialMessages.length > 0 ? lastNonInitialIndex : messagesBeforeUser.length - 1;
  const { items: handoffMessages } = takeConsecutiveFromEnd(
    messagesBeforeUser,
    isHandoffDataMessage,
    handoffSearchStartIndex
  );
  return { initialMessages, handoffMessages };
}

var CopilotMode = /* @__PURE__ */ ((CopilotMode2) => {
  CopilotMode2["autoBuild"] = "auto_build";
  CopilotMode2["askAsYouBuild"] = "ask_as_you_build";
  return CopilotMode2;
})(CopilotMode || {});

var FeedbackValue = /* @__PURE__ */ ((FeedbackValue2) => {
  FeedbackValue2["GOOD"] = "Good";
  FeedbackValue2["BAD"] = "Bad";
  return FeedbackValue2;
})(FeedbackValue || {});
var FeedbackType = /* @__PURE__ */ ((FeedbackType2) => {
  FeedbackType2["THUMBS_UP"] = "thumbsUp";
  FeedbackType2["THUMBS_DOWN"] = "thumbsDown";
  return FeedbackType2;
})(FeedbackType || {});
var FeedbackSentiment = /* @__PURE__ */ ((FeedbackSentiment2) => {
  FeedbackSentiment2["POSITIVE"] = "positive";
  FeedbackSentiment2["NEGATIVE"] = "negative";
  return FeedbackSentiment2;
})(FeedbackSentiment || {});

export { CopilotMode as C, FeedbackValue as F, TOOL_CANCELLED_RESULT as T, FeedbackType as a, FeedbackSentiment as b, createHandoffDataMessages as c, isHandoffDataMessage as d, findImmediateHandoffAndInitialMessages as f, generateRandomUUID as g, idempotentMapToStructuredInitialMessages as i };
//# sourceMappingURL=types-B7iPQtvw.mjs.map
